import { useState } from "react";
import axios from "axios";
import useAxiosConfig from "../../../config/useAxiosConfig";

const useTechPrepEmail = () => {
  const { loading: axiosLoading, error: axiosError } = useAxiosConfig();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Helper: wait until axios config is ready (axiosLoading becomes false)
  const waitForAxiosReady = (timeoutMs = 10000) => {
    return new Promise((resolve, reject) => {
      const interval = 100;
      let waited = 0;
      const timer = setInterval(() => {
        if (!axiosLoading) {
          clearInterval(timer);
          resolve(true);
        } else {
          waited += interval;
          if (waited >= timeoutMs) {
            clearInterval(timer);
            reject(new Error("Axios configuration not ready (timeout)"));
          }
        }
      }, interval);
    });
  };

  // send expects an object payload: { toEmail, subject, body, jsStruct }
  const send = async (payload = {}) => {
    setLoading(true);
    setError(null);
    try {
      // Wait for axios defaults/interceptors to be applied by useAxiosConfig
      if (axiosLoading) {
        console.log("useTechPrepEmail: waiting for axios config to be ready...");
        try {
          await waitForAxiosReady(10000);
        } catch (e) {
          console.warn("useTechPrepEmail: axios config wait timed out", e);
          // proceed anyway; request may still succeed if external URL is used
        }
      }

      const toEmail = payload.toEmail || "";
      const subject = payload.subject || "";
      const body = payload.body || "";
      const jsStruct =
        typeof payload.jsStruct === "string"
          ? payload.jsStruct
          : JSON.stringify(payload.jsStruct || {});

      // Use URLSearchParams so ColdFusion receives form-encoded arguments reliably
      const params = new URLSearchParams();
      params.append("toEmail", toEmail);
      params.append("subject", subject);
      params.append("body", body);
      params.append("jsStruct", jsStruct);

      // Determine endpoint (allow full URL override via env for testing)
      const endpoint = process.env.REACT_APP_TECHPREP_EMAIL_URL || `/TechPrepShowcaseEmail/`;

      // Helpful debug logs — inspect final payload and auth header
      console.log("useTechPrepEmail: sending to", endpoint);
      try {
        console.log(
          "useTechPrepEmail: axios Authorization header:",
          axios.defaults && axios.defaults.headers && axios.defaults.headers.common
            ? axios.defaults.headers.common["Authorization"]
            : undefined,
        );
      } catch (e) {
        console.warn("useTechPrepEmail: could not read axios Authorization header", e);
      }
      console.log("useTechPrepEmail: payload (urlencoded)=", params.toString());

      const response = await axios.post(
        endpoint,
        params.toString(),
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } },
      );

      console.log("useTechPrepEmail: response status", response.status, response.data);
      setLoading(false);
      return response.data;
    } catch (err) {
      console.error("useTechPrepEmail: Error sending Tech Prep email:", err);
      setError(err);
      setLoading(false);
      throw err;
    }
  };

  return {
    send,
    loading,
    error,
  };
};
export default useTechPrepEmail;
